const { signal } = require("@preact/signals");

export const organisationSignal = signal(null);